import { useState } from "react"

export const CustomInput = ({ updateProducto, producto, field = '', editable = false }) => {

    let value = producto[field]
    if(field === 'Precio') {
        value = Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(producto[field])
    }

    const [inputValue, setInputValue] = useState(value)

    const handleChange = (e) => {
        setInputValue(e.target.value)
    }

    const handleBlur = (e) => {
        updateProducto(producto, field, e.target.value)
    }

    return (
        <input 
        className="text-sm bg-transparent border-none focus:ring-0" 
        type='text' 
        readOnly={!editable}
        onChange={handleChange} 
        onBlur={handleBlur}
        value={inputValue}
        /> 
    )
}